
import {defineComponent} from 'vue';
import InputNumber from 'primevue/inputnumber';

export default defineComponent({
  name: "NumberPicker",
  components: {InputNumber},
  props: {
    name: { type: String, require: true },
    value: { type: Number, required: true },
    placeholder: {type: Number, required: true},
  },
  data () {
    return {
      selected: this.value
    }
  },
  watch: {
    selected() {
      this.$emit('select', {key: this.name, value: this.selected})
    }
  }
})
